import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import EntitySelector from '@components/EntitySelector'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useCreatePublicationPaginationRuleModal from './hooks/useCreatePublicationPaginationRuleModal'

const MODAL_KEY = 'CreatePublicationPaginationRuleModal'

type ModalCallbacks = {
  closeModal: () => void,
  createPublicationPaginationRule: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const CreatePublicationPaginationRuleModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal, createPublicationPaginationRule } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { publicationPaginationRule } = modalPayload

  const modalHookPayload = useCreatePublicationPaginationRuleModal({ closeModal, publicationPaginationRule })

  const {
    callbacks: {
      handleBrandSelector,
    },
    brandId,
    createPublicationPaginationRulePayload,
    creating,
    publicationPaginationRuleFormPayload,
    unassignedPaginationRules,
  } = modalHookPayload

  const {
    entityState: {
      pagination_rule_id,
    },
    errors,
    handlers,
    saveEnabled,
  } = publicationPaginationRuleFormPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Add" titleSecondLine="Pagination Rule" />

      <SidebarModal.Content>
        <Form>
          <EntitySelector
            callbacks={{
              // @ts-expect-error TS2345
              selectItem: brand => handleBrandSelector(brand),
            }}
            entityKey="brands"
            label="* Brand"
            requestOptions={{ include_brand_pagination_rules: true }}
            // @ts-expect-error TS2322
            selectedItemId={brandId}
          />

          {brandId && (
            <Form.Field
              errorMessage={errors.pagination_rule_id}
              label="* Pagination Rule"
              marginTop="large"
            >
              {/*
               // @ts-expect-error TS2322 */}
              <select
                name="pagination_rule_id"
                value={pagination_rule_id}
                {...handlers}
              >
                <option value="">Please Select...</option>
                {unassignedPaginationRules.map(paginationRule => (
                  <option key={paginationRule.id} value={paginationRule.id}>
                    {paginationRule.title}
                  </option>
                ))}
              </select>
            </Form.Field>
          )}
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => createPublicationPaginationRule(createPublicationPaginationRulePayload)}
          size="large"
        >
          {saveEnabled ? 'Add Pagination Rule' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <CreatePublicationPaginationRuleModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
